import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-dynamic-action-template",
  templateUrl: "./dynamic-action-template.component.html",
  styleUrls: ["./dynamic-action-template.component.css"],
})
export class DynamicActionTemplateComponent implements OnInit {
  @Input() operation = "delete";
  @Output() formSubmit = new EventEmitter<void>();
  currentValue = "";

  constructor() {
    // Put any necessary code to initialize the component here
  }

  ngOnInit(): void {
    // Put any necessary code to initialize the component here
  }

  clearField(): void {
    this.currentValue = "";
  }

  submitForm() {
    this.formSubmit.emit();
  }
}
